import React from 'react';
import { FadeIn, Section } from './ui';
import { Star } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    initial: 'M',
    color: 'bg-brand-blue',
    name: 'Mariela G.',
    city: 'Buenos Aires',
    text: 'Llevaba 8 años dando clases y nunca había tenido un sistema. Pensaba que la improvisación era parte del trabajo. En la primera semana que usé el Framework GPM, el 3°B me prestó atención los 40 minutos completos. Algo que nunca había pasado.'
  }, {
    initial: 'R',
    color: 'bg-brand-orange',
    name: 'Rodrigo T.',
    city: 'Córdoba',
    text: 'El Tomo 4 solo vale todo el precio. Tuve un padre que vino a reclamar la nota de su hijo. Le mostré la rúbrica. La conversación duró 3 minutos. Nunca me había pasado eso.'
  }, {
    initial: 'V',
    color: 'bg-green-600',
    name: 'Valeria M.',
    city: 'Rosario',
    text: 'Antes me quedaba hasta medianoche preparando las clases. Ahora tardo 20 minutos con los scripts y las plantillas del Tomo 1 y 2. El domingo dejó de ser el día más estresante de la semana.'
  }, {
    initial: 'C',
    color: 'bg-purple-600',
    name: 'Carlos F.',
    city: 'Mendoza',
    text: 'Los prompts de ChatGPT del Bonus 2 me cambiaron la vida. Genero un banco de ejercicios completo para toda la unidad en 15 minutos. Antes eso me llevaba un fin de semana entero.'
  }];
  return <Section variant="light" className="!max-w-none" data-id="element-232">
      <div className="max-w-[800px] mx-auto" data-id="element-233">
        <FadeIn data-id="element-234">
          <h2 className="text-[28px] md:text-4xl font-black text-white mb-10 text-center" data-id="element-235">
            Lo que dicen los docentes que ya lo usan:
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-236">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-237">
              <div className="bg-dark p-6 rounded-2xl border border-gray-800 h-full flex flex-col" data-id="element-238">
                <div className="flex items-center gap-4 mb-4" data-id="element-239">
                  <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-xl shrink-0`} data-id="element-240">
                    {t.initial}
                  </div>
                  <div data-id="element-241">
                    <h4 className="text-white font-bold" data-id="element-242">{t.name}</h4>
                    <p className="text-gray-400 text-sm" data-id="element-243">{t.city}</p>
                  </div>
                  <div className="ml-auto flex" data-id="element-244">
                    {[...Array(5)].map((_, idx) => <Star key={idx} size={16} className="text-brand-gold fill-brand-gold" data-id="element-245" />)}
                  </div>
                </div>
                <p className="text-gray-300 italic text-sm md:text-base leading-relaxed flex-grow" data-id="element-246">
                  "{t.text}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}